import React from 'react';
import { ArrowLeft, Wand2, AlertCircle } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';
import GroupingStep from '../GroupingStep';
import GroupAssignmentStep from '../GroupAssignmentStep';
import WizardFrame from './WizardFrame';

/**
 * Wizard step 3 of 4 — only reached for formats where `needsGroupsStep` is
 * true (see useScheduleBuilder). Group/region count (or a "Fixed" badge for
 * formats like Dual Meet that are always exactly 2 sides) plus the actual
 * name-to-group assignment editor.
 */
const ConfigureGroupsStep = ({ format, config, updateConfig, groupAssignments, onMoveParticipant, onRandomizeGroups, backToParameters, generate, error }) => {
  const { theme } = useTheme();
  const { participantCount, groupingConfig, groupNames } = config;
  const onRenameGroup = (idx, name) => updateConfig((prev) => ({ groupNames: { ...prev.groupNames, [idx]: name } }));

  return (
    <WizardFrame
      title="Configure groups"
      footer={
        <>
          <button
            type="button"
            onClick={backToParameters}
            className={`flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${theme.buttonGhost}`}
          >
            <ArrowLeft size={16} />
            Back
          </button>
          <button
            type="button"
            onClick={() => generate()}
            className={`flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold transition-all ${theme.shadow} ${theme.buttonPrimary} hover:opacity-90 active:scale-[0.99]`}
          >
            <Wand2 size={16} />
            Generate Schedule
          </button>
        </>
      }
    >
      {groupingConfig && (
        <GroupingStep
          format={format}
          participantCount={participantCount}
          groupingConfig={groupingConfig}
          onChange={(gc) => updateConfig({ groupingConfig: gc })}
        />
      )}

      {groupAssignments && (
        <div className="mt-4">
          <GroupAssignmentStep
            format={format}
            groups={groupAssignments}
            groupNames={groupNames}
            onRename={onRenameGroup}
            onMove={onMoveParticipant}
            onRandomize={onRandomizeGroups}
          />
        </div>
      )}

      {error && (
        <div className="mt-3 flex items-center gap-2 rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-500">
          <AlertCircle size={15} />
          {error}
        </div>
      )}
    </WizardFrame>
  );
};

export default ConfigureGroupsStep;
